import store from '@/store/index'
import { Actions } from '@/store/enums/store.enums'
import ApiService from '@/core/services/ApiService'
import LocalStorageService from '@/core/services/LocalStorageService'
import { ElMessage } from 'element-plus'

const removeTokens = () => {
  store.dispatch(Actions.SET_IS_LOGGED_OUT)
  store.dispatch(Actions.DESTROY_ACCESS_TOKEN)
  store.dispatch(Actions.DESTROY_REFRESH_TOKEN)
  LocalStorageService.destroyToken('accessToken')
  LocalStorageService.destroyToken('refreshToken')
}

/**
 * @description refresh the access token.
 */
const refreshToken = async () => {
  const refreshTokenValue = LocalStorageService.getToken('refreshToken')
  if (!refreshTokenValue) {
    removeTokens()
    return false
  }

  return await ApiService.post('/admin/auth/refresh', {
    'refresh_token': refreshTokenValue,
  })
    .then(response => {
      console.log('> Refresh >> SUCCESS')
      store.dispatch(Actions.SET_IS_LOGGED_IN)
      store.dispatch(Actions.SET_ACCESS_TOKEN, response.data.access_token)
      store.dispatch(Actions.SET_REFRESH_TOKEN, response.data.refresh_token)
      LocalStorageService.saveToken('accessToken', response.data.access_token)
      LocalStorageService.saveToken('refreshToken', response.data.refresh_token)
      ApiService.setHeader()
      return true
    })
    .catch(() => {
      console.log('> Refresh >> Error')
      removeTokens()
      return false
    })
}

/**
 * @description detect expirtaion time of the auth token.
 */
const isTokenExpired = () => {
  const token = LocalStorageService.getToken('accessToken')
  return token ? 200 : 400
}

/**
 * @description login by email and password.
 */
const logIn = async (params): Promise<boolean> => {
  ApiService.setHeader()

  return await ApiService.post('/admin/auth/login', params)
    .then(response => {
      store.dispatch(Actions.SET_IS_LOGGED_IN)
      store.dispatch(Actions.SET_ACCESS_TOKEN, response.data.access_token)
      store.dispatch(Actions.SET_REFRESH_TOKEN, response.data.refresh_token)
      LocalStorageService.saveToken('accessToken', response.data.access_token)
      LocalStorageService.saveToken('refreshToken', response.data.refresh_token)
      ApiService.setHeader()
      return true
    })
    .catch(error => {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        ElMessage.warning(error.response.data.message)
      } else {
        ElMessage.warning(error)
      }
      removeTokens()
      return false
    })
}

export default { isTokenExpired, refreshToken, removeTokens, logIn }
